<button appPreventDoubleClick pButton pRipple class="p-button-outlined btnBlueColored" pTooltip="Update Effective Date" tooltipPosition="left" icon="fa fa-calendar" 
id="updateEffectiveDateBtn" iconPos="left" (debounceClick)="click()"></button>
